"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var label_1 = require("./label");
var checkbox_1 = require("./checkbox");
var radio_1 = require("./radio");
var label_2 = require("./label");
exports.NgbButtonLabel = label_2.NgbButtonLabel;
var checkbox_2 = require("./checkbox");
exports.NgbCheckBox = checkbox_2.NgbCheckBox;
var radio_2 = require("./radio");
exports.NgbRadio = radio_2.NgbRadio;
exports.NgbRadioGroup = radio_2.NgbRadioGroup;
var NGB_BUTTON_DIRECTIVES = [label_1.NgbButtonLabel, checkbox_1.NgbCheckBox, radio_1.NgbRadioGroup, radio_1.NgbRadio];
var NgbButtonsModule = /** @class */ (function () {
    function NgbButtonsModule() {
    }
    NgbButtonsModule_1 = NgbButtonsModule;
    NgbButtonsModule.forRoot = function () { return { ngModule: NgbButtonsModule_1, providers: [] }; };
    NgbButtonsModule = NgbButtonsModule_1 = __decorate([
        core_1.NgModule({ declarations: NGB_BUTTON_DIRECTIVES, exports: NGB_BUTTON_DIRECTIVES })
    ], NgbButtonsModule);
    return NgbButtonsModule;
    var NgbButtonsModule_1;
}());
exports.NgbButtonsModule = NgbButtonsModule;
//# sourceMappingURL=buttons.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/buttons/buttons.module.js
// module id = 33
// module chunks = 0